export const INIT_FILTERS = 'companyExperience/views/interviewRequestList/INIT_FILTERS'
export const APPLY_FILTER = 'companyExperience/views/interviewRequestList/APPLY_FILTER'
export const APPLY_FILTER_FORM = 'companyExperience/views/interviewRequestList/APPLY_FILTER_FORM'
export const CLEAR_FILTERS = 'companyExperience/views/interviewRequestList/CLEAR_FILTERS'
export const TOGGLE_ARCHIVED = 'companyExperience/views/interviewRequestList/TOGGLE_ARCHIVED'

export const FETCH_POSITIONS = 'companyExperience/views/interviewRequestList/FETCH_POSITIONS'
export const FETCH_POSITIONS_SUCCESS = 'companyExperience/views/interviewRequestList/FETCH_POSITIONS_SUCCESS'
export const FETCH_POSITIONS_ERROR = 'companyExperience/views/interviewRequestList/FETCH_POSITIONS_ERROR'

export const FETCH_MEMBERS = 'companyExperience/views/interviewRequestList/FETCH_MEMBERS'
export const FETCH_MEMBERS_SUCCESS = 'companyExperience/views/interviewRequestList/FETCH_MEMBERS_SUCCESS'
export const FETCH_MEMBERS_ERROR = 'companyExperience/views/interviewRequestList/FETCH_MEMBERS_ERROR'

export const FETCH_INTERVIEW_REQUESTS = 'companyExperience/views/interviewRequestList/FETCH_INTERVIEW_REQUESTS'
export const FETCH_INTERVIEW_REQUESTS_SUCCESS = 'companyExperience/views/interviewRequestList/FETCH_INTERVIEW_REQUESTS_SUCCESS'
export const FETCH_INTERVIEW_REQUESTS_ERROR = 'companyExperience/views/interviewRequestList/FETCH_INTERVIEW_REQUESTS_ERROR'

export const INTERVIEW_REQUEST_POLLING_INIT = 'companyExperience/views/interviewRequestList/INTERVIEW_REQUEST_POLLING_INIT'
export const INTERVIEW_REQUEST_POLLING_END = 'companyExperience/views/interviewRequestList/INTERVIEW_REQUEST_POLLING_END'

export const UPDATE_INTERVIEW_REQUEST = 'companyExperience/views/interviewRequestList/UPDATE_INTERVIEW_REQUEST'
export const UPDATE_INTERVIEW_REQUEST_SUCCESS = 'companyExperience/views/interviewRequestList/UPDATE_INTERVIEW_REQUEST_SUCCESS'
export const UPDATE_INTERVIEW_REQUEST_ERROR = 'companyExperience/views/interviewRequestList/UPDATE_INTERVIEW_REQUEST_ERROR'

export const ARCHIVE_INTERVIEW_REQUEST = 'companyExperience/views/interviewRequestList/ARCHIVE_INTERVIEW_REQUEST'
export const ARCHIVE_INTERVIEW_REQUEST_SUCCESS = 'companyExperience/views/interviewRequestList/ARCHIVE_INTERVIEW_REQUEST_SUCCESS'
export const ARCHIVE_INTERVIEW_REQUEST_ERROR = 'companyExperience/views/interviewRequestList/ARCHIVE_INTERVIEW_REQUEST_ERROR'

export const TOGGLE_WITHDRAW_INTERVIEW_REQUEST = 'companyExperience/views/interviewRequestList/TOGGLE_WITHDRAW_INTERVIEW_REQUEST'
export const WITHDRAW_INTERVIEW_REQUEST = 'companyExperience/views/interviewRequestList/WITHDRAW_INTERVIEW_REQUEST'
export const WITHDRAW_INTERVIEW_REQUEST_SUCCESS = 'companyExperience/views/interviewRequestList/WITHDRAW_INTERVIEW_REQUEST_SUCCESS'
export const WITHDRAW_INTERVIEW_REQUEST_ERROR = 'companyExperience/views/interviewRequestList/WITHDRAW_INTERVIEW_REQUEST_ERROR'

export const FETCH_UNAVAILABLE_CANDIDATE_NOTIFICATIONS =
  'companyExperience/views/unavailableCandidateNotifications/FETCH_UNAVAILABLE_CANDIDATE_NOTIFICATIONS'
export const FETCH_UNAVAILABLE_CANDIDATE_NOTIFICATIONS_SUCCESS =
  'companyExperience/views/unavailableCandidateNotifications/FETCH_UNAVAILABLE_CANDIDATE_NOTIFICATIONS_SUCCESS'
export const FETCH_UNAVAILABLE_CANDIDATE_NOTIFICATIONS_ERROR =
  'companyExperience/views/unavailableCandidateNotifications/FETCH_UNAVAILABLE_CANDIDATE_NOTIFICATIONS_ERROR'
export const DISMISS_UNAVAILABLE_CANDIDATE_NOTIFICATIONS =
  'companyExperience/views/unavailableCandidateNotifications/DISMISS_UNAVAILABLE_CANDIDATE_NOTIFICATIONS'
export const RESET_UNAVAILABLE_CANDIDATE_NOTIFICATION_COUNT =
  'companyExperience/views/unavailableCandidateNotifications/RESET_UNAVAILABLE_CANDIDATE_NOTIFICATION_COUNT'
export const initFilters = () => ({
  type: INIT_FILTERS,
})

export const applyFilter = (filters, replace) => ({
  type: APPLY_FILTER,
  meta: {
    filters,
    replace: replace || false,
  },
})

export const applyFilterForm = (filters, formResolve, formReject) => ({
  type: APPLY_FILTER_FORM,
  meta: {
    filters,
    formResolve,
    formReject,
  },
})

export const clearFilters = () => ({
  type: CLEAR_FILTERS,
})

export const toggleArchived = archived => ({
  type: TOGGLE_ARCHIVED,
  meta: { archived },
})

export const fetchPositions = () => ({
  type: FETCH_POSITIONS,
  meta: {
    params: {
      archived: false,
      order_by: 'name',
      order_direction: 'asc',
      paginate: false,
    },
  },
  payload: {
    fetchingPositions: true,
    fetchPositionsError: null,
  },
})

export const fetchPositionsSuccess = ({ result }) => ({
  type: FETCH_POSITIONS_SUCCESS,
  payload: {
    fetchingPositions: false,
    lastUpdatedPositions: Date.now(),
    positions: result.map(position => position.id),
  },
})

export const fetchPositionsError = errorMessage => ({
  type: FETCH_POSITIONS_ERROR,
  error: true,
  payload: new Error(errorMessage),
})

export const fetchMembers = () => ({
  type: FETCH_MEMBERS,
  meta: {
    params: {
      order_by: 'name',
      order_direction: 'asc',
      has_sent_interview_request: true,
      paginate: false,
    },
  },
  payload: {
    fetchingMembers: true,
    fetchMembersError: null,
  },
})

export const fetchMembersSuccess = ({ result }) => ({
  type: FETCH_MEMBERS_SUCCESS,
  payload: {
    fetchingMembers: false,
    lastUpdatedMembers: Date.now(),
    members: result.map(member => member.id),
  },
})

export const fetchMembersError = errorMessage => ({
  type: FETCH_MEMBERS_ERROR,
  error: true,
  payload: new Error(errorMessage),
})

export const fetchInterviewRequests = () => ({
  type: FETCH_INTERVIEW_REQUESTS,
  meta: {
    params: {
      order_by: 'last_message',
      order_direction: 'desc',
      items_per_page: 15,
    },
  },
  payload: {
    fetchingInterviewRequests: true,
    fetchInterviewRequestsError: null,
  },
})

export const fetchInterviewRequestsSuccess = ({ pagination_info, result, total_open }) => ({
  type: FETCH_INTERVIEW_REQUESTS_SUCCESS,
  payload: {
    fetchingInterviewRequests: false,
    lastUpdatedInterviewRequests: Date.now(),
    interviewRequests: result.map(interviewRequest => interviewRequest.id),
    interviewRequestsStats: result.reduce((map, item) => {
      map[item.id] = defaultStats
      return map
    }, {}),
    interviewRequestPagination: pagination_info,
    interviewRequestsOpenHiringTeam: total_open,
  },
})

export const fetchInterviewRequestsError = errorMessage => ({
  type: FETCH_INTERVIEW_REQUESTS_ERROR,
  error: true,
  payload: new Error(errorMessage),
})

export const interviewRequestPollingInit = () => ({
  type: INTERVIEW_REQUEST_POLLING_INIT,
})

export const interviewRequestPollingEnd = () => ({
  type: INTERVIEW_REQUEST_POLLING_END,
})

export const updateInterviewRequest = (interviewRequestId, data, previousData) => ({
  type: UPDATE_INTERVIEW_REQUEST,
  meta: { interviewRequestId, data, previousData },
  payload: {
    updating: true,
    updateError: null,
  },
})

export const updateInterviewRequestSuccess = (interviewRequestId, { result }) => ({
  type: UPDATE_INTERVIEW_REQUEST_SUCCESS,
  meta: { interviewRequestId },
  payload: {
    updating: false,
    lastUpdated: Date.now(),
  },
})

export const updateInterviewRequestError = (interviewRequestId, errorMessage) => ({
  type: UPDATE_INTERVIEW_REQUEST_ERROR,
  meta: { interviewRequestId },
  error: true,
  payload: new Error(errorMessage),
})

export const archiveInterviewRequest = (interviewRequestId, data) => ({
  type: ARCHIVE_INTERVIEW_REQUEST,
  meta: { interviewRequestId, data },
  payload: {
    archiving: true,
    archiveError: null,
  },
})

export const archiveInterviewRequestSuccess = (interviewRequestId, { result }) => ({
  type: ARCHIVE_INTERVIEW_REQUEST_SUCCESS,
  meta: { interviewRequestId },
})

export const archiveInterviewRequestError = (interviewRequestId, errorMessage) => ({
  type: ARCHIVE_INTERVIEW_REQUEST_ERROR,
  meta: { interviewRequestId },
  error: true,
  payload: new Error(errorMessage),
})

export const toggleWithdrawInterviewRequest = interviewRequestId => ({
  type: TOGGLE_WITHDRAW_INTERVIEW_REQUEST,
  payload: { interviewRequestToWithdraw: interviewRequestId },
})

export const withdrawInterviewRequest = (interviewRequestId, formResolve, formReject) => ({
  type: WITHDRAW_INTERVIEW_REQUEST,
  meta: { interviewRequestId, formResolve, formReject },
  payload: {
    withdrawing: true,
    withdrawError: null,
  },
})

export const withdrawInterviewRequestSuccess = (interviewRequestId, { result }) => ({
  type: WITHDRAW_INTERVIEW_REQUEST_SUCCESS,
  meta: { interviewRequestId },
  payload: {
    lastUpdatedInterviewRequests: Date.now(),
    interviewRequestToWithdraw: null,
  },
})

export const withdrawInterviewRequestError = (interviewRequestId, errorMessage) => ({
  type: WITHDRAW_INTERVIEW_REQUEST_ERROR,
  meta: { interviewRequestId },
  error: true,
  payload: new Error(errorMessage),
})

export const fetchUnavailableCandidateNotifications = () => ({
  type: FETCH_UNAVAILABLE_CANDIDATE_NOTIFICATIONS,
  payload: {
    fetchingUnavailableNotifications: true,
    unavailableNotificationsError: null,
  },
})

export const fetchUnavailableCandidateNotificationsSuccess = ({ result }) => ({
  type: FETCH_UNAVAILABLE_CANDIDATE_NOTIFICATIONS_SUCCESS,
  payload: {
    fetchingUnavailableNotifications: false,
    lastUpdatedUnavailableNotifications: Date.now(),
    candidatePlacedCount: result.unread_candidate_placed_count,
    automaticallyArchivedCount: result.unread_automatically_archived_count,
  },
})

export const fetchUnavailableCandidateNotificationsError = errorMessage => ({
  type: FETCH_UNAVAILABLE_CANDIDATE_NOTIFICATIONS_ERROR,
  error: true,
  payload: new Error(errorMessage),
})

export const dismissUnavailableCandidateNotifications = notificationType => ({
  type: DISMISS_UNAVAILABLE_CANDIDATE_NOTIFICATIONS,
  meta: { unavailable_reason: notificationType },
  payload: {
    lastUpdatedUnavailableNotifications: Date.now(),
  },
})

export const resetUnavailableCandidateNotificationCount = notificationCount => ({
  type: RESET_UNAVAILABLE_CANDIDATE_NOTIFICATION_COUNT,
  payload: notificationCount,
})

const defaultStats = {
  updating: false,
  updateError: null,
  archiving: false,
  archiveError: null,
  withdrawing: false,
  withdrawError: null,
  lastUpdated: null,
}

const stats = (state = defaultStats, { type, payload }) => {
  switch (type) {
    case UPDATE_INTERVIEW_REQUEST:
    case UPDATE_INTERVIEW_REQUEST_SUCCESS:
    case ARCHIVE_INTERVIEW_REQUEST:
    case WITHDRAW_INTERVIEW_REQUEST:
      return { ...state, ...payload }

    case UPDATE_INTERVIEW_REQUEST_ERROR:
      return { ...state, updating: false, updateError: payload }

    case ARCHIVE_INTERVIEW_REQUEST_ERROR:
      return { ...state, archiving: false, archiveError: payload }

    case WITHDRAW_INTERVIEW_REQUEST_ERROR:
      return { ...state, withdrawing: false, withdrawError: payload }

    default:
      return state
  }
}

const defaultView = {
  fetchingPositions: false,
  fetchPositionsError: null,
  lastUpdatedPositions: null,
  positions: [],

  fetchingMembers: false,
  fetchMembersError: null,
  lastUpdatedMembers: null,
  members: [],

  fetchingInterviewRequests: false,
  fetchInterviewRequestsError: null,
  lastUpdatedInterviewRequests: null,
  interviewRequests: [],
  interviewRequestsStats: {},
  interviewRequestPagination: {
    current_page: 0,
    items_per_page: 0,
    total_items: 0,
    total_pages: 0,
  },
  interviewRequestsOpenHiringTeam: 0,
  interviewRequestToWithdraw: null,

  fetchingUnavailableNotifications: false,
  unavailableNotificationsError: null,
  lastUpdatedUnavailableNotifications: null,
  candidatePlacedCount: 0,
  automaticallyArchivedCount: 0,
}

const view = (state = defaultView, { type, meta, payload }) => {
  switch (type) {
    case FETCH_POSITIONS:
    case FETCH_POSITIONS_SUCCESS:
    case FETCH_MEMBERS:
    case FETCH_MEMBERS_SUCCESS:
    case FETCH_INTERVIEW_REQUESTS:
    case FETCH_INTERVIEW_REQUESTS_SUCCESS:
    case TOGGLE_WITHDRAW_INTERVIEW_REQUEST:
    case FETCH_UNAVAILABLE_CANDIDATE_NOTIFICATIONS:
    case FETCH_UNAVAILABLE_CANDIDATE_NOTIFICATIONS_SUCCESS:
    case DISMISS_UNAVAILABLE_CANDIDATE_NOTIFICATIONS:
    case RESET_UNAVAILABLE_CANDIDATE_NOTIFICATION_COUNT:
      return { ...state, ...payload }

    case FETCH_POSITIONS_ERROR:
      return { ...state, fetchingPositions: false, fetchPositionsError: payload }

    case FETCH_MEMBERS_ERROR:
      return { ...state, fetchingMembers: false, fetchMembersError: payload }

    case FETCH_INTERVIEW_REQUESTS_ERROR:
      return { ...state, fetchingInterviewRequests: false, fetchInterviewRequestsError: payload }

    case FETCH_UNAVAILABLE_CANDIDATE_NOTIFICATIONS_ERROR:
      return { ...state, fetchingUnavailableNotifications: false, unavailableNotificationsError: payload }

    case UPDATE_INTERVIEW_REQUEST:
    case UPDATE_INTERVIEW_REQUEST_SUCCESS:
    case UPDATE_INTERVIEW_REQUEST_ERROR:
    case ARCHIVE_INTERVIEW_REQUEST:
    case ARCHIVE_INTERVIEW_REQUEST_ERROR:
    case WITHDRAW_INTERVIEW_REQUEST:
    case WITHDRAW_INTERVIEW_REQUEST_ERROR:
      return {
        ...state,
        interviewRequestsStats: {
          ...state.interviewRequestsStats,
          [meta.interviewRequestId]: stats(state.interviewRequestsStats[meta.interviewRequestId], { type, payload }),
        },
      }

    case ARCHIVE_INTERVIEW_REQUEST_SUCCESS:
    case WITHDRAW_INTERVIEW_REQUEST_SUCCESS:
      const { [meta.interviewRequestId]: toRemove, ...newStats } = state.interviewRequestsStats
      const newTotalItems = state.interviewRequestPagination.total_items - 1

      return {
        ...state,
        ...payload,
        interviewRequestPagination: {
          ...state.interviewRequestPagination,
          total_items: newTotalItems,
          total_pages: Math.ceil(newTotalItems / state.interviewRequestPagination.items_per_page),
        },
        interviewRequestsOpenHiringTeam: state.interviewRequestsOpenHiringTeam - 1,
        interviewRequests: state.interviewRequests.filter(id => id !== meta.interviewRequestId),
        interviewRequestsStats: newStats,
      }

    default:
      return state
  }
}

export default view

export const getInterviewRequestListView = state => state.views.interviewRequestList
